import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import ProfilePage from './pages/ProfilePage';
import HSEQPage from './pages/HSEQPage';
import FleetPage from './pages/FleetPage';
import ProjectsPage from './pages/ProjectsPage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import MaintenanceScreen from './components/MaintenanceScreen';
import './App.css';

const API_BASE = (process.env.REACT_APP_API_URL || 'https://api.petro-marine.net').replace(/\/$/, '');

const BootSplash: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-ocean-900">
    <img src="/logo.jpg" alt="PetroMarine" className="w-20 h-20 rounded-full object-cover opacity-90" />
  </div>
);

const AppLayout: React.FC = () => {
  const location = useLocation();
  // The fixed header floats over the home hero; other pages need an offset.
  const needsHeaderOffset = location.pathname !== '/';

  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className={`flex-1 ${needsHeaderOffset ? 'pt-24' : ''}`}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/hse-q" element={<HSEQPage />} />
          <Route path="/fleet" element={<FleetPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  // ERP-controlled maintenance gate: when on, every route (including
  // direct/shared links) renders the maintenance screen instead of the site.
  // Fails open — an API error must not take the site down.
  const [maintenance, setMaintenance] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/api/website/maintenance`, { cache: 'no-store' })
      .then((r) => r.json())
      .then((j) => { if (!cancelled) setMaintenance(!!j?.data?.maintenanceMode); })
      .catch(() => { if (!cancelled) setMaintenance(false); });
    return () => { cancelled = true; };
  }, []);

  if (maintenance === null) return <BootSplash />;
  if (maintenance) return <MaintenanceScreen />;

  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;